export default __webpack_public_path__ + "static/media/pdf1.72fb877a.png";